export enum NavRoutes {
  TRADESHOWS = "TRADE SHOWS",
  EVENTS = "EVENTS",
  POPUPS = "POP UPS",
  RETAIL = "RETAIL SPACES",
}
